import { Box, Typography } from '@vp/swan';
import { ConfirmationCard } from './ConfirmationCard';

export function TileCard({
    imageUrl,
    name,
    imageHeight,
    imageObjectFit = 'cover',
}: {
    imageUrl?: string;
    name: string;
    imageHeight?: number;
    imageObjectFit?: 'cover' | 'fill';
}) {
    return (
        <ConfirmationCard width={imageUrl ? '120px' : undefined}>
            {imageUrl && (
                <img
                    src={imageUrl}
                    alt={name}
                    style={{
                        width: '100%',
                        height: `${imageHeight}px`,
                        objectFit: imageObjectFit,
                        display: 'block',
                    }}
                />
            )}
            <Box paddingY={imageUrl ? 2 : 4} paddingX={imageUrl ? 3 : 5}>
                <Typography
                    fontSkin="body-small-bold"
                    style={{ textAlign: imageUrl ? 'center' : undefined }}
                >
                    {name}
                </Typography>
            </Box>
        </ConfirmationCard>
    );
}
